import script from "./LightDarkSwtichBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./LightDarkSwtichBtn.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__